// Schema contract returned by AdminUCDatabaseMapController::ajaxProcessSchema().

export interface SchemaColumn {
    name: string;
    type: string;
    pk: boolean;
    nullable: boolean;
    key: string;
    fk?: string; // "referenced_table.referenced_column"
}

export interface SchemaTable {
    name: string;
    type: string; // "BASE TABLE" | "VIEW"
    engine: string | null;
    rows: number | null;
    external: boolean; // true for boundary ps_* tables
    columns: SchemaColumn[];
}

export interface SchemaRelation {
    from: string;
    fromCol: string;
    to: string;
    toCol: string;
    constraint: string;
}

export interface Schema {
    tables: SchemaTable[];
    relations: SchemaRelation[];
}

// Data carried on a React Flow node.
export interface TableNodeData {
    table: SchemaTable;
    cluster: string;
    color: string;
    dimmed: boolean;
    [key: string]: unknown; // satisfies @xyflow Node data constraint
}
